import { useTheme } from '@mui/system'
import { FillLayer, Layer } from 'react-map-gl/dist/es5'
import { MapTheme } from '../../../'

interface SelectableLayerProps extends Omit<FillLayer, 'type'> {
  defaultFillColor?: string
  hideSelectedGeometries?: boolean
}

export const SelectableLayer = ({
  defaultFillColor,
  id,
  hideSelectedGeometries,
  ...layerProps
}: SelectableLayerProps) => {
  const theme = useTheme<MapTheme>()

  return (
    <>
      <Layer
        {...layerProps}
        beforeId="data-layer-anchor"
        id={id}
        type="fill"
        paint={{
          'fill-color': [
            'case',
            ['boolean', ['feature-state', 'select'], false],
            hideSelectedGeometries ? 'transparent' : theme.palette.selectFill,
            ['boolean', ['feature-state', 'hover'], false],
            theme.palette.hoverFill,
            defaultFillColor ? defaultFillColor : 'transparent',
          ],
        }}
      />
      <Layer
        {...layerProps}
        id={`${id}-highlight-stroke`}
        type="line"
        paint={{
          'line-color': [
            'case',
            ['boolean', ['feature-state', 'select'], false],
            hideSelectedGeometries ? 'transparent' : 'white',
            'transparent',
          ],
          'line-opacity': 1,
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 9, 12, 11],
        }}
      />
      <Layer
        {...layerProps}
        id={`${id}-base`}
        type="line"
        paint={{
          'line-color': [
            'case',
            ['boolean', ['feature-state', 'select'], false],
            theme.palette.selectLine,
            'transparent',
          ],
          'line-opacity': 1,
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 4, 12, 7],
        }}
      />
      {/* separating out hover onto a separate layer ensures that the outline is always visible */}
      <Layer
        {...layerProps}
        id={`${id}-highlight`}
        type="line"
        paint={{
          'line-color': [
            'case',
            [
              'all',
              ['!=', ['boolean', ['feature-state', 'select'], false], true],
              ['boolean', ['feature-state', 'hover'], false],
            ],
            theme.palette.hoverLine,
            'transparent',
          ],
          'line-opacity': 1,
          'line-width': ['interpolate', ['linear'], ['zoom'], 10, 4, 12, 7],
        }}
      />
    </>
  )
}
